import script from "./ScriptHistoryByDatabase.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptHistoryByDatabase.vue?vue&type=script&setup=true&lang=js"

import "./ScriptHistoryByDatabase.vue?vue&type=style&index=0&id=454fd76e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454fd76e"]])

export default __exports__